// src/pages/HelpCancellations.jsx
import React, { useState } from "react";
import { FaCalendarTimes } from "react-icons/fa";
import "./Help.css";

const FAQItem = ({ q, a, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="hc_faq_item">
      <button
        className="hc_faq_q"
        aria-expanded={open}
        onClick={() => setOpen((s) => !s)}
      >
        <span className="hc_q_text">{q}</span>
        <span className="hc_q_icon">{open ? "−" : "+"}</span>
      </button>
      <div className={`hc_faq_a ${open ? "open" : ""}`} role="region">
        <p>{a}</p>
      </div>
    </div>
  );
};

const HelpCancellations = () => {
  return (
    <section className="hc_container" aria-labelledby="hc_heading">
      <header className="hc_header">
        <div className="hc_icon_wrap" aria-hidden="true">
          <FaCalendarTimes size={28} />
        </div>
        <div>
          <h2 id="hc_heading" className="hc_title">Cancellations</h2>
          <p className="hc_subtitle">
            Everything you need to know about cancelling bookings and fees.
          </p>
        </div>
      </header>

      <div className="hc_content">
        <FAQItem
          defaultOpen
          q="Can I cancel my booking?"
          a="Yes, you can cancel your booking at any time. However, cancellation terms and any applicable fees are determined by the property’s individual policy. You can review these details in your booking confirmation or under “My Bookings” in your YOVHO account."
        />

        <FAQItem
          q="Will I be charged a cancellation fee?"
          a="If your booking includes free cancellation, you won’t be charged any fee as long as you cancel within the allowed period. For non-refundable or expired free-cancellation bookings, a cancellation fee may apply as per the property’s policy. Any such fee is paid directly to the property."
        />

        <FAQItem
          q="Can I cancel or change the dates of a non-refundable booking?"
          a="Non-refundable bookings usually can’t be changed or canceled without a charge. However, in some cases, you can request a waiver through your YOVHO account or by contacting your YOVHO Captain. The property may review your request and, at its discretion, allow a one-time cancellation without penalty — though this isn’t guaranteed."
        />

        <FAQItem
          q="How do I know if my booking was successfully canceled?"
          a="Once you cancel your booking, you’ll immediately receive a confirmation email from YOVHO. Please also check your spam or junk folder just in case. If you don’t receive a confirmation within 24 hours, contact YOVHO Support or your property directly to verify your cancellation."
        />

        <FAQItem
          q="Where can I find my cancellation policy?"
          a="You can view your cancellation policy anytime in your booking confirmation email or in your YOVHO account under “My Bookings.” This section clearly shows whether your stay includes free cancellation, the last date to cancel without charge, and any applicable fees afterward."
        />
      </div>

      <footer className="hc_footer">
        <a className="hc_cta" href="/help/cancellations#contact-support">
          Contact YOVHO Support
        </a>
        <small className="hc_note">
          If you need immediate help, call: <a href="tel:+923310222068">+92 331 0222068</a>
        </small>
      </footer>
    </section>
  );
};

export default HelpCancellations;
